import { jsx as _jsx } from "react/jsx-runtime";
import { KmReading as PuiKmReading } from "@ploy-ui/km-reading";
import KmReadingAPI from "@ploy-lib/km-reading-api";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: theme.spacing(8),
        padding: theme.spacing(4)
    }
}));
const dtResultToOptions = (dtResult) => ({
    allowedMonths: Number.parseInt(dtResult["kmReadingAllowedMonths"]),
    allowedDeviation: Number.parseFloat(dtResult["kmReadingAllowedDeviation"]),
    percentInterval: Number.parseFloat(dtResult["kmReadingPercentageInterval"]),
    doCalculation: dtResult["kmReadingDoCalculation"] === "false" ? false : true,
    canEditUntilApproved: dtResult["kmReadingCanEditUntilApproved"] === "true",
    hideDateInput: dtResult["kmReadingHideDateInput"] === "true",
    hideCommentSection: dtResult["kmReadingHideCommentSection"] === "true",
    hideDeliveryDate: dtResult["kmReadingHideDeliveryDate"] === "true",
    messages: {
        lessThanPlanned: dtResult["informationMessage1"],
        lessThanAllowed: dtResult["informationMessage2"],
        lessThanInterval: dtResult["informationMessage4"],
        large: dtResult["informationMessage3"],
        kmReadingNotAvailable: dtResult["informationMessage5"]
    }
});
export const KmReading = ({ dtResult, token = "", endpoint, internalUser }) => {
    const classes = useStyles();
    return (_jsx("div", { className: classes.root, children: _jsx(KmReadingAPI, { token: token, endpoint: endpoint, children: api => (_jsx(PuiKmReading, { ...api, options: dtResultToOptions(dtResult), isInternal: !!internalUser })) }) }));
};
export default KmReading;
//# sourceMappingURL=KmReading.js.map